import React from "react";

const InputText = ({ value, setValue,placeholder,title,required=true,disabled=false}) => {
  return (
    <div className="my-3">
      <label
        htmlFor={title}
        class="block w-full text-xs font-medium text-gray-900 dark:text-white"
      >
        {title}
      </label>
      <input
        type="text"
        id={title}
        disabled={disabled}
        value={value}
        onChange={(e)=>setValue(e.target.value)}
        className="border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 "
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
};

export default InputText;
